<template>
  <div
    class="document-details-row"
    :class="{'small-screen': isSmallScreen}"
    ref="row"
    @click="$emit('click', document)">
    <resize-observer @notify="handleResize" />

    <div class="doc-title vc-ellipsis">{{fileName}}</div>

    <div class="doc-date pull-to-end" v-if="document.time_sent_h">
      {{document.time_sent_h}}
    </div>

    <div class="doc-with">
      <span class="staff-name" v-if="showStaff">{{document.staff.display_name}}</span>
      <span class="seperator" v-if="showStaff">|</span>
      <span class="file-size">{{document.size_in_kb}}</span>
    </div>

    <div
      class="doc-direction">
      <DocDirection :direction="document.direction" />
    </div>
  </div>
</template>

<script>
import DocDirection from './DocDirection'
export default {
  name: "DocumentDetailsRow",
  components: {
    DocDirection
  },
  props: {
    document: {
      type: Object,
      required: true
    },
    showStaff: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      rowWidth: 0,
    }
  },
  mounted() {
    const rowEl = this.$refs.row
    this.handleResize({width: rowEl.offsetWidth})
  },
  computed: {
    fileName() {
      return this.document.title || this.document.name
    },
    isSmallScreen() {
      return this.rowWidth < 600
    },
  },
  methods: {
    handleResize ({ width }) {
      this.rowWidth = width
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import '@/assets/scss/abstract/_i18n-mixins';

.document-details-row {
  display: grid;
  grid-template-columns: 50% 25% 25%;
  width: 100%;
  padding: 0 20px;
  font-family: var(--primary-font-family);
  grid-row-gap: 3px;

  grid-template-areas:
    "title direction date"
    "with with with";

  &.v-list-item__content {
    text-transform: initial;
  }

  &.small-screen {
    grid-template-columns: auto auto;
    grid-template-areas:
      "title date"
      "with direction";

    .doc-direction {
      display: flex;
      justify-content: flex-end;
    }
  }

  .doc-title {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.38;
    letter-spacing: -0.2px;
    color: $black-color-1;
    grid-area: title;
    @include i-padding-mirror(0, 10px);
  }

  .doc-with {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: -0.2px;
    color: $grey-color-6;
    grid-area: with;
    display: flex;

    .seperator {
      color: $grey-color-2;
      margin: 0 6px;
    }
  }

  .doc-date {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: -0.2px;
    color: $grey-color-6;
    grid-area: date;
  }

  .doc-direction {
    display: flex;
    align-items: center;
    font-weight: 600;
    grid-area: direction;
  }

  .pull-to-end {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
